import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { UserComponent } from './user/user.component';
import { ProductsDocsComponent } from './products-docs/products-docs.component';
import { CheckOutComponent } from './check-out/check-out.component';
import { OrderSummaryComponent } from './order-summary/order-summary.component';


const routes: Routes =
  [
    {
      path:'',
      component: UserComponent,
      children: [
        {
          path: '',
         component: ProductsDocsComponent
        },
        {
          path: 'search',
          component: ProductsDocsComponent
        },
        {
         path: 'check-out',
         component: CheckOutComponent
        },
        {
          path: 'order-summary/:id',
          component: OrderSummaryComponent
        }
      ]
    }
  ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UserRoutingModule { }
